// extracted by mini-css-extract-plugin
export default {"Color":"EditUserModal_Color__3DVtg"};